import styled from 'styled-components';
import {AppButton} from '../Common/Buttons/AppButton';

export const StyledAppButton = styled(AppButton)`
    width: 100%;
`;
